import { callProcedure, transformToProcedurePayload } from 'clickNgo/helpers/api'
import type { IProcedureResponse } from 'clickNgo/models/api'

import { parseDraftNumber } from '../lib/formatters'
import type { PartnerDevicesInfoSavePayload } from '../model/types'

export const savePartnerDevicesInfo = async ({
  partnerId,
  fYear,
  draft,
}: PartnerDevicesInfoSavePayload): Promise<void> => {
  const a3AllBrands = parseDraftNumber(draft.a3AllBrands)
  const a3HpBrand = parseDraftNumber(draft.a3HpBrand)
  const a4AllBrands = parseDraftNumber(draft.a4AllBrands)
  const a4HpBrand = parseDraftNumber(draft.a4HpBrand)

  if (a3AllBrands === null || a3HpBrand === null || a4AllBrands === null || a4HpBrand === null) {
    throw new Error('Partner devices info contains invalid values.')
  }

  const response = await callProcedure<IProcedureResponse<unknown> | unknown>({
    url: '/webservice/621/sp/v3/spJBPDeviceInfoApplyChanges/call',
    method: 'POST',
    data: {
      ...transformToProcedurePayload({
        partnerId,
        fYear,
      }),
      'p.Data': JSON.stringify([
        {
          A3AllBrands: a3AllBrands,
          A3HP: a3HpBrand,
          A4AllBrands: a4AllBrands,
          A4HP: a4HpBrand,
        },
      ]),
    },
  })

  if ('error' in response) {
    throw response.error
  }
}
